import { Avatar, Card, Flex, Modal } from 'antd';
import agbColors from 'constants/Colors/agbColors';
import { useLanguage } from 'hooks/Language/useLanguage';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import urls from 'routes/urls';
import { MobileOutlined } from '@ant-design/icons';
import { CalendarSync, ChevronRight, Globe } from 'lucide-react';

interface TransferOptionsProps {
  isModalOpen: boolean;
  handleClose: () => void;
}

const TransferOptions: React.FC<TransferOptionsProps> = ({
  isModalOpen,
  handleClose,
}) => {
  const navigate = useNavigate();
  const { translate } = useLanguage();

  const handleNavigate = ({
    url,
    title,
  }: {
    url: string;
    title: string;
  }) => {
    navigate(url, { state: { chosenOption: title } });
  };

  return (
    <Modal
      title={translate('Transfer to')}
      open={isModalOpen}
      onCancel={handleClose}
      footer={[]}
    >
      <Flex gap="small" vertical>
        <Card
          size="small"
          onClick={() =>
            handleNavigate({
              url: urls.transferBetweenOwnAccount,
              title: translate('Between own accounts'),
            })
          }
          hoverable
        >
          <Flex
            justify="space-between"
            align="center"
            className="small-padding"
          >
            <Flex gap="middle" align="center">
              <Avatar
                size={35}
                icon={
                  <CalendarSync
                    size={20}
                    strokeWidth={1}
                    className="segmented-icon"
                  />
                }
                style={{ background: agbColors.navyBlueColor }}
              />
              <span>{translate('Between own accounts')}</span>
            </Flex>
            <ChevronRight strokeWidth={1} size={20} />
          </Flex>
        </Card>
        <Card
          size="small"
          onClick={() =>
            handleNavigate({
              url: urls.localTransfer,
              title: translate('Transfer'),
            })
          }
          hoverable
        >
          <Flex
            justify="space-between"
            align="center"
            className="small-padding"
          >
            <Flex gap="middle" align="center">
              <Avatar
                size={35}
                icon={
                  <Globe
                    strokeWidth={1}
                    size={20}
                    className="segmented-icon"
                  />
                }
                style={{ background: agbColors.navyBlueColor }}
              />
              <span>{translate('Transfer')}</span>
            </Flex>
            <ChevronRight strokeWidth={1} size={20} />
          </Flex>
        </Card>
        <Card
          size="small"
          onClick={() =>
            handleNavigate({
              url: urls.localTransfer,
              title: translate('Operator'),
            })
          }
          hoverable
        >
          <Flex
            justify="space-between"
            align="center"
            className="small-padding"
          >
            <Flex gap="middle" align="center">
              <Avatar
                size={35}
                icon={<MobileOutlined />}
                style={{ background: agbColors.navyBlueColor }}
              />
              <span>{translate('Operator')}</span>
            </Flex>
            <ChevronRight strokeWidth={1} size={20} />
          </Flex>
        </Card>
      </Flex>
    </Modal>
  );
};

export default TransferOptions;
